import React from 'react'
import { observer } from 'mobx-react-lite'
import Input from '../../../../../../../../components/FormComponents/Input'

export default observer(function TikTokInsightForm({ formProps }) {
  const { handleBlur, handleChange, values, touched, errors } = formProps
  
  return (
    <div className='flex flex-col gap-2'>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.reach && errors.reach} 
            noLabelPadding 
            label="Reach" 
            placeholder="Reach" 
            name='reach' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.reach} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.impressions && errors.impressions} 
            noLabelPadding 
            label="Impressions" 
            placeholder="Impressions" 
            name='impressions' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.impressions} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.likes && errors.likes} 
            noLabelPadding 
            label="Likes" 
            placeholder="Likes" 
            name='likes' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.likes} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.comments && errors.comments} 
            noLabelPadding 
            label="Comments" 
            placeholder="Comments" 
            name='comments' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.comments} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.shares && errors.shares} 
            noLabelPadding 
            label="Shares" 
            placeholder="Shares" 
            name='shares' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.shares} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.saves && errors.saves} 
            noLabelPadding 
            label="Saves" 
            placeholder="Saves" 
            name='saves' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.saves} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.reel_duration && errors.reel_duration} 
            noLabelPadding 
            label="Video Duration" 
            placeholder="Video Duration" 
            name='reel_duration' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.reel_duration} 
          />
        </div>
        <div>
          <Input 
            overrideClassName="pl-4 h-8" 
            topMargin={false} 
            error={touched.watchtime && errors.watchtime} 
            noLabelPadding 
            label="Watchtime" 
            placeholder="Watchtime" 
            name='watchtime' 
            onChange={handleChange} 
            onBlur={handleBlur} 
            value={values.watchtime} 
          />
        </div>
      </div>
      <div className="px-18">
        <Input 
          overrideClassName="pl-4 h-8" 
          topMargin={false} 
          addon="%"
          addonPosition="end"
          error={touched.watchtime_percentage && errors.watchtime_percentage} 
          noLabelPadding 
          label="Percentage of video watched" 
          placeholder="Watchtime Percentage" 
          name='watchtime_percentage' 
          onChange={handleChange} 
          onBlur={handleBlur} 
          value={values.watchtime_percentage} 
        />
      </div>
    </div>
  )
})
